import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    userCount: 0,
    videoCount: 0,
    sessionCount: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [users, videos, sessions] = await Promise.all([
          api.getUsers(1, 1),
          api.getVideos(1, 1),
          api.getVideoSessions(1, 1),
        ]);

        setStats({
          userCount: users.total || 0,
          videoCount: videos.total || 0,
          sessionCount: sessions.total || 0,
        });
      } catch (error) {
        console.error('Failed to fetch stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="content-section">
      <h1>Dashboard</h1>

      <div className="welcome-card">
        <h2>Welcome, {user?.full_name || user?.username}!</h2>
        {user?.organization_name && (
          <p className="org-name">Organization: {user.organization_name}</p>
        )}
        {user?.is_super_admin && (
          <p className="role-badge">Super Admin</p>
        )}
      </div>

      {!loading && (
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-value">{stats.userCount}</div>
            <div className="stat-label">Users</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.videoCount}</div>
            <div className="stat-label">Videos</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{stats.sessionCount}</div>
            <div className="stat-label">Video Sessions</div>
          </div>
        </div>
      )}

      {loading && <p>Loading stats...</p>}
    </div>
  );
}

export default Dashboard;
